import { CONFIG } from '../../api/config';
import { logout } from '../../api/endpoints/authentication';
import { handleError } from '../../api/utils';

export const useLogout = () => {
  return async () => {
    try {
      await logout();
      window.location.href = CONFIG.MANAGER_PORTAL;
    } catch (error) {
      handleError(error);
    }
  };
};
